<div class="dashboard-data-dialog" *ngIf="menuData?.length !== 1">
  <div class="title">
    <mat-icon class="settings">settings</mat-icon>
    <div class="title-text">{{title}}</div>
    <mat-icon (click)="dialogRef.close()" class="close-icon">close</mat-icon>
  </div>
  <div class="ddd-content">
    <div *ngFor="let data of menuData" class="ddd-content-block" (click)="navigateToSubPage(data.navigateTo, data.data.title)">
      {{data.data.title}}
    </div>
  </div>
</div>
